
import React from 'react';



type Props = {
  className?: string;
}
export const ServiceTechconsultingVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'white' d = 'M14 10.5001C15.0821 11.3123 15.8404 12.4128 15.8404 13.88V16.5001H19V13.88C19 11.9761 16.1801 10.8495 14 10.5001Z' />
      <path fill = 'white' d = 'M12.2477 10.5001C14.3208 10.5001 16 8.93387 16 7.00012C16 5.06637 14.3208 3.50012 12.2477 3.50012C11.8068 3.50012 11.394 3.58762 11 3.71012C11.7786 4.61137 12.2477 5.75762 12.2477 7.00012C12.2477 8.24262 11.7786 9.38887 11 10.2901C11.394 10.4126 11.8068 10.5001 12.2477 10.5001Z' />
      <path fill = 'white' d = 'M7.5 10.5001C9.43375 10.5001 11 8.93387 11 7.00012C11 5.06637 9.43375 3.50012 7.5 3.50012C5.56625 3.50012 4 5.06637 4 7.00012C4 8.93387 5.56625 10.5001 7.5 10.5001ZM7.5 5.25012C8.4625 5.25012 9.25 6.03762 9.25 7.00012C9.25 7.96262 8.4625 8.75012 7.5 8.75012C6.5375 8.75012 5.75 7.96262 5.75 7.00012C5.75 6.03762 6.5375 5.25012 7.5 5.25012Z' />
      <path fill = 'white' d = 'M7.5 10.5001C5.33063 10.5001 1 11.6487 1 13.9287V16.5001H14V13.9287C14 11.6487 9.66938 10.5001 7.5 10.5001ZM12.375 14.7858H2.625V13.9373C2.7875 13.3201 5.30625 12.2144 7.5 12.2144C9.69375 12.2144 12.2125 13.3201 12.375 13.9287V14.7858Z' />
    </svg>
  );
};
